<template>
  <Modal :value="visible" @on-cancel="cancelHandler" footer-hide
    :title="currApiSetting && currApiSetting.id ? '编辑接口' : '增加接口'" width="500">
    <div class="container">
      <Form :model="formData" ref="form" label-position='left' :label-width="100">
        <FormItem label="名称" prop="name">
          <Input v-model="formData.name" placeholder="" />
        </FormItem>
        <FormItem label="接口地址" prop="url">
          <Input v-model="formData.url" placeholder="" />
        </FormItem>
        <FormItem label="方法" prop="method">
          <Select v-model="formData.method">
            <Option value="GET">GET</Option>
            <Option value="POST">POST</Option>
          </Select>
        </FormItem>
        <FormItem label="接口内容" prop="content">
          <Input v-model="formData.content" placeholder="" />
        </FormItem>
        <FormItem label="内容类型" prop="content_type">
          <Select v-model="formData.content_type">
            <Option value="text/plain">text/plain</Option>
            <Option value="text/xml">text/xml</Option>
            <Option value="application/xml">application/xml</Option>
            <Option value="application/json">application/json</Option>
            <Option value="application/x-www-form-urlencoded">application/x-www-form-urlencoded</Option>
          </Select>
        </FormItem>
        <Divider />
        <div class="extension-info" v-if="[974, 4679, 109598, 106997, 107938, 107932, 107949, 107964, 112260].includes(company.id)">
          <h4>扩展信息</h4>
          <div class="section-title">Headers</div>
          <div v-for="(header, index) in formData.headers" :key="'header-' + index" class="dynamic-item">
            <Input v-model="header.key" placeholder="Key" style="width: 45%; margin-right: 5px;" />
            <Input v-model="header.value" placeholder="Value" style="width: 45%; margin-right: 5px;" />
            <Button type="error" size="small" @click="removeHeader(index)" icon="md-trash"></Button>
          </div>
          <Button type="dashed" size="small" @click="addHeader" style="width: 100%; margin-top: 5px;">
            <Icon type="md-add" /> 添加 Header
          </Button>

          <div class="section-title" style="margin-top: 15px;">
            配置变量
            <Tooltip max-width="200"
              content="【示例】名称：用户邀请码，参数：activateCode，变量：${extra:YQM}">
              <Icon type="ios-help-circle-outline" style="cursor: help;"/>
            </Tooltip>
          </div>
          <div v-for="(variable, index) in formData.param" :key="'variable-' + index" class="dynamic-item">
            <Input v-model="variable.name" placeholder="名称" style="width: 30%; margin-right: 5px;" />
            <Input v-model="variable.key" placeholder="Key" style="width: 30%; margin-right: 5px;" />
            <Input v-model="variable.vars" placeholder="Value" style="width: 30%; margin-right: 5px;" />
            <Button type="error" size="small" @click="removeVariable(index)" icon="md-trash"></Button>
          </div>
          <Button type="dashed" size="small" @click="addVariable" style="width: 100%; margin-top: 5px;">
            <Icon type="md-add" /> 添加配置变量
          </Button>
        </div>
        <div class="flex flex-end" style="margin-top: 20px;">
          <Button style="margin-right: 20px" @click="cancelHandler">取消</Button>
          <Button type="primary" @click="submit">确定</Button>
        </div>
      </Form>
    </div>
  </Modal>
</template>
<script>
import { addNodeId } from '@/utils/nodeIdPool';
import { FormItem } from 'view-design';
import { mapState } from 'vuex'

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currApiSetting: {
      type: Object,
    }
  },
  data() {
    return {
      formData: {
        name: '',
        url: '',
        content: '',
        method: 'POST',
        content_type: 'application/json',
        headers: [],
        param: [],
      },
    }
  },
  computed: {
    ...mapState('user', ['company']),
  },
  watch: {
    currApiSetting(val) {
      if (!val) return
      const header = Object.keys(val.headers || {}).map(key => ({ key, value: val.headers[key] }))
      this.formData = {
        ...val,
        headers: header,
        param: val.param || []
      }
    },
    // ratings(val) {
    //   if (this.visible) return;
    //   this.formData.number = this.getNextNumber();
    // },
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const data = {
          ...this.formData,
          type: 0,
          headers: this.formData.headers.reduce((acc, cur) => {
            acc[cur.key] = cur.value;
            return acc;
          }, {}),
        }
        this.$emit('onSubmit', data);
        this.cancelHandler();
      })
    },
    cancelHandler() {
      this.$refs.form.resetFields()
      this.formData = {
        name: '',
        url: '',
        content: '',
        method: 'POST',
        content_type: 'application/json',
        headers: [],
        param: [],
      }
      this.$emit('change', false)
      this.$emit('onCancel')
    },
    addHeader() {
      this.formData.headers.push({
        key: '',
        value: ''
      })
    },
    removeHeader(index) {
      this.formData.headers.splice(index, 1)
    },
    addVariable() {
      this.formData.param.push({
        name: '',
        key: '',
        vars: ''
      })
    },
    removeVariable(index) {
      this.formData.param.splice(index, 1)
    },
    getNextNumber() {
      return addNodeId()
      // const nums = Object.keys(this.ratings);
      // if (nums.length === 0) return 0;
      // const maxNum = Math.max(...nums);
      // return maxNum + 1;
    },
  }
}
</script>
<style lang="scss" scoped>
.extension-info {
  h4 {
    margin-bottom: 10px;
    font-weight: 600;
    color: #333;
  }

  .section-title {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    margin-bottom: 8px;
    margin-top: 12px;
  }

  .dynamic-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
}
</style>